<template>
  <section class="sal-card">
    <div class="sal-section-head">
      <h1 class="sal-section-title">Parámetros de Producción</h1>
    </div>

    <SALDropdown
      v-model="localForm.producto"
      label="Producto"
      placeholder="Selecciona producto"
      :options="productos"
      :error="errors.producto"
      error-message="Selecciona un producto."
      @select="handleProductoSelect"
    />

    <SALDropdown
      v-model="localForm.color"
      label="Color"
      placeholder="Selecciona color"
      :options="colores"
      :error="errors.color"
      error-message="Selecciona un color."
      @select="handleColorSelect"
    />

    <!--
      Pregunta explícita Sí / No, sin valor por defecto: el operador debe
      elegir. El botón único anterior ("Sin aditivo" / "Con aditivo") se leía
      como una opción a seleccionar y al tocarlo se invertía el valor.
    -->
    <div class="sal-field">
      <span id="sal-aditivo-label" class="sal-form-label">¿Lleva aditivo?</span>
      <div
        class="sal-aditivo-options"
        role="radiogroup"
        aria-labelledby="sal-aditivo-label"
      >
        <button
          v-for="opcion in opcionesAditivo"
          :key="opcion.label"
          type="button"
          class="sal-aditivo-toggle"
          :class="{
            'is-active': localForm.aditivo === opcion.value,
            'is-error': errors.aditivo,
          }"
          role="radio"
          :aria-checked="localForm.aditivo === opcion.value"
          @click="seleccionarAditivo(opcion.value)"
        >
          <i
            class="bi"
            :class="localForm.aditivo === opcion.value ? opcion.iconoActivo : opcion.icono"
            aria-hidden="true"
          ></i>
          <span>{{ opcion.label }}</span>
        </button>
      </div>
      <p v-if="errors.aditivo" class="sal-error-message">
        Indica si el producto lleva aditivo.
      </p>
    </div>
  </section>
</template>

<script setup>
import { computed } from "vue";

import SALDropdown from "../components/SALDropdown.vue";

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  productos: {
    type: Array,
    default: () => [],
  },
  colores: {
    type: Array,
    default: () => [],
  },
  errors: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(["update:modelValue", "field-change"]);

const localForm = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

function handleProductoSelect(option) {
  localForm.value.productoLabel = option.label;
  notifyFieldChange("producto");
}

const opcionesAditivo = [
  { value: true,  label: "Sí", icono: "bi-check-circle", iconoActivo: "bi-check-circle-fill" },
  { value: false, label: "No", icono: "bi-x-circle",     iconoActivo: "bi-x-circle-fill" },
];

function seleccionarAditivo(value) {
  localForm.value.aditivo = value;
  notifyFieldChange("aditivo");
}

function notifyFieldChange(field) {
  emit("field-change", { field });
}

function handleColorSelect(option) {
  localForm.value.colorLabel = option.label;
  localForm.value.colorHex = option.hex || "";
  notifyFieldChange("color");
}
</script>
